/* eslint-disable max-len */

import moment from 'moment'
import { i18n } from 'next-i18next'

export const getActualDateFormated = () => {
  var d = new Date()
  return [d.getFullYear(), d.getMonth(), d.getDate()].join('_')
}

export const getTransformedDate = (date: any) => {
  return !date ? null : moment(date).format('YYYY-MM-DD')
}

export const getTransformedDateTime = (date: any) => {
  return [undefined, null].includes(date) ? null : moment(date).format('YYYY-MM-DD HH:mm')
}

export const getSmallTransformedDate = (date: string) => {
  return moment(date, 'DD/MM/YYYY').format('ll')
}

export const getMonthFromDate = (date) => {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  date = new Date(date)
  const month = date.getMonth()
  return monthNames[month]
}

export const getDateFormatted = (dateValue: any, hour12 = false) => {
  const options = {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: 'numeric', weekday: 'short', hour12: hour12
  } as const
  const date = new Date(dateValue)
  return date.toLocaleString(i18n.language, options)
}

export const getDateFormattedSmall = (dateValue: any) => {
  const options = { year: 'numeric', month: 'short', day: 'numeric' } as const
  const date = new Date(dateValue)
  return date.toLocaleString(i18n.language, options)
}


const todayLang = { es: 'Hoy', en: 'Today', fr: "Aujourd'hui", ko: '오늘', de: 'Heute', pt: 'Hoje', it: 'In data odierna', pl: 'Dzisiaj' }
const yesterdayLan = { es: 'Ayer', en: 'Yesterday', fr: 'Hier', ko: '어제', de: 'Gestern', pt: 'Ontem', it: 'Ieri', pl: 'Wczoraj' }

export const getNaturalDate  = (dateParam: any) => {
  const date = new Date(dateParam)
  const today = new Date()
  if (date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
  ) {
    return todayLang[i18n.language] || 'Today'
  }
  if (date.getDate() === (today.getDate() - 1) &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
  ) {
    return yesterdayLan[i18n.language] || 'Yesterday'
  }
  let dia: any = date.getDate()
  if (date.getDate() < 10) { dia = '0' + date.getDate() }
  const month: any = date.getMonth() + 1
  let monthString = month
  if (monthString < 10) { monthString = '0' + monthString }
  const newDate = dia + '/' + monthString + '/' + date.getFullYear()
  return newDate
}

export const getOnlyHour = (dateParam: any) => {
  const date = new Date(dateParam)
  const hour = date.getHours()
  let minuts: any = date.getMinutes()
  if (minuts < 10) {
    minuts = '0' + minuts
  }
  const newHour = hour + ':' + minuts
  return newHour
}

const months = {
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  es: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  fr: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
  ko: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  pt: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  de: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
  it: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
  pl: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień']
}

export const getHumanizeDate = (dateParam: any) => {
  const date = new Date(dateParam)
  const today = new Date()
  if (date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
  ) {
    return todayLang[i18n.language] || 'Today'
  }
  if (date.getDate() === (today.getDate() - 1)
      && date.getMonth() === today.getMonth()
      && date.getFullYear() === today.getFullYear()
  ) {
    return yesterdayLan[i18n.language] || 'Yesterday'
  }
  let day: any = date.getDate()
  if (date.getDate() < 10) { day = '0' + date.getDate() }
  const month = date.getMonth()
  const monthString = (months[i18n.language][month])
  const newDate = monthString + ' ' + day + ', ' + getOnlyHour(dateParam)
  return newDate
}

export const transformDate3 = (dateParam: Date | string) => {
  const date = new Date(dateParam)
  let day = date.getDate()
  if (date.getDate() < 10) { day = +('0' + date.getDate()) }
  const month = date.getMonth()
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ]
  const monthString = (monthNames[month])
  return `${monthString} ${day} ${getOnlyHour(dateParam)}`
}
